require('../base.js')
var Cube = require('cube-js')

var fixed_scene = require('./home/fixed_scene.js');
var Videoplayer = require('./home/videoplayer');
var Frameplayer = require('./home/frameplayer');

var Home = function() {
  this.header = $('#header');
  this.menu = $('.home-dropdown-menu');
  this.last_y = 0;
  this.init();
};

Cube.mix(Home.prototype, {

  menu: null,
  window_width: 0,
  window_height: 0,
  videoplayer: null,
  frameplayer: null,
  fixed_scene1: null,
  fixed_scene2: null,
  last_y: 0,

  init: function() {

    var header = this.header;

    this.window_width = $(window).width();
    this.window_height = $(window).height();

    if (this.window_width >= 768) {
      $('.timelapse-item img').each(function(item) {
        var item = $(this);
        item.attr('src', item.data('src'));
      });
    }

    this.videoplayer = new Videoplayer({'container': $('#home-timelapse')});
    this.frameplayer = new Frameplayer({'container': $('.bloomsky-app-feature')});

    this.fixed_scene1 = new fixed_scene({'container': $('#device-scene-list')});
    this.fixed_scene2 = new fixed_scene({'container': $('#app-scene-list')});

    this.updateResponsive();

    var me = this;

    $(window).on("scroll", function() {
      me.onScroll();
    });
    $(window).on("resize", function() {
      me.onResize();
    });
    $(window).scrollTop(0);
    this.tryToRedirectForMobileGetApp();
  },

  tryToRedirectForMobileGetApp: function() {
    var hash = window.location.hash;
    if (hash == '#getapp' && this.mobileAndTabletcheck()) {
      window.location.href = 'http://onelink.to/gcmq62';
    }
  },

  mobileAndTabletcheck: function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  },

  onScroll: function() {

    var scrool_top = $(window).scrollTop();
    var scrool_bottom = scrool_top + this.window_height;

    var detal = scrool_top - this.last_y;
    if (Math.abs(detal) > 10) {
      this.last_y = scrool_top;
      if (this.window_width < 768) {
        this.menu.collapse('hide');
      }
    }

    this.fixed_scene1.onScroll(scrool_top, scrool_bottom);
    this.fixed_scene2.onScroll(scrool_top, scrool_bottom);
    this.videoplayer.onScroll(scrool_top);
  },

  decideItemSize: function(element) {

    // 60^414<414|70^414<768|250
    // splited by | each item:
    // width(,height)(^design_width=1920)(<when_size_small_than)|...
    var window_width = this.window_width;
    var size = element.data('size');
    if (!size) {
      return;
    }
    if (typeof size == 'string') {
      var list = size.split('|');
      for (var i = 0; i < list.length; i++) {

        var item = list[i];
        var l_1 = this.spList(item, '<', 19200);
        var size_and_design_raw = l_1[0]
        var max_size = l_1[1];
        var l_2 = this.spList(size_and_design_raw, '^', 1920);

        var size_raw = l_2[0];
        var design = l_2[1];
        var l_3 = this.spList(size_raw, ',', 0);

        var width = l_3[0];
        var height = l_3[1];

        if (window_width < max_size) {
          var ratio = window_width / design;
          element.css('width', width * ratio + 'px');
          if (height) {
            element.css('height', height * ratio + 'px');
          }
          return;
        }
      }
    } else {
      var ratio = window_width / 1920;
      element.css('width', size * ratio + 'px');
    }
  },

  decideZone: function(element, key, attr) {
    // top,right,bottom,left(^design_width=1920)(<when_size_small_than)|...
    var window_width = this.window_width;
    var size = element.data(key);
    if (!size) {
      return;
    }
    if (typeof size != 'string') {
      return;
    }
    var list = size.split('|');
    for (var i = 0; i < list.length; i++) {

      var item = list[i];
      var l_1 = this.spList(item, '<', 19200);
      var size_and_design_raw = l_1[0]
      var max_size = l_1[1];
      var l_2 = this.spList(size_and_design_raw, '^', 1920);

      var zone_raw = l_2[0];
      var design = l_2[1];

      var l_3 = zone_raw.split(',');

      if (window_width < max_size) {
        var ratio = window_width / design;
        var l_3 = Cube.map(l_3, function(value, index) {
          return value * ratio + 'px';
        });
        element.css(attr, l_3.join(' '));
        return;
      }
    }
  },

  spList: function(str, sp, default_value) {
    var list = str.split(sp);
    if (list.length == 1) {
      list.push(default_value);
    }
    return list;
  },

  updateResponsive: function() {

    this.fixed_scene1.updateSize(this.window_width, this.window_height);
    this.fixed_scene2.updateSize(this.window_width, this.window_height);

    var window_width = this.window_width;
    var ratio = window_width / 1920;
    var me = this;

    $('.responsive').each(function() {
      var element = $(this);
      me.decideZone(element, 'margin', 'margin');
      me.decideZone(element, 'padding', 'padding');
      me.decideItemSize($(this));
    });
  },

  onResize: function() {

    this.window_width = $(window).width();
    this.window_height = $(window).height();

    this.videoplayer.onResize();
    this.frameplayer.onResize();

    this.updateResponsive();
  },
});

jQuery.extend(jQuery.easing, {
  def: "easeOutQuad",
  easeOutQuad: function(_a, _b, _c, _d, _e) {
    return -_d * (_b /= _e) * (_b - 2) + _c
  },
  easeInOutExpo: function(_a, _b, _c, _d, _e) {
    return 0 == _b ? _c : _b == _e ? _c + _d : (_b /= _e / 2) < 1 ? _d / 2 * Math.pow(2, 10 * (_b - 1)) + _c : _d / 2 * (-Math.pow(2, -10 * --_b) + 2) + _c
  }
}),

$(document).ready(function() {

  function load_image(img_list, callback, on_error, on_progress) {
    var f, img, loaded_count = 0;
    for (f = 0; f < img_list.length; f++) {
      img = new Image;
      img.onload = function() {
        loaded_count++;
        if (on_progress) {
          on_progress(100 * (loaded_count / img_list.length));
        }
        if (loaded_count == img_list.length && callback) {
          callback();
        }
        this.onload = this.onerror = null;
        this.src = "";
      };
      img.onerror = function() {
        on_error && on_error(this.src),
        on_error = callback = on_progress = null
      };
      img.src = img_list[f];
    }
  }

  function load_image_callback() {
    setTimeout(function() {
      document.body.style.display = "block",
      loading_element.style.background = "none",
      loading_element_div.setAttribute("class", "out"),
      bind_event(),
      setTimeout(function() {
        loading_element.style.display = "none"
      }, 1350)
    }, 1200);
  }

  function prepare() {

    document.body.style.display = "none";

    var loading_element = document.createElement("div");
    loading_element.setAttribute("id", "loading");
    loading_element.innerHTML = "<div><em></em></div>";
    document.body.parentNode.appendChild(loading_element);
    var loading_element_div = loading_element.getElementsByTagName("div")[0];
    var loading_element_em = loading_element.getElementsByTagName("em")[0];

    var img_elements = document.getElementsByTagName("img");

    var img_list  = [];
    for (var f = 0; f < img_elements.length; f++) {
      img_list.push(img_elements[f].src);
    }
    load_image(img_list, load_image_callback, function() {
      console.log("image loading errors, please reflash.")
    }, function(_a) {
      var _b = Math.ceil(_a) + "%";
      loading_element_em.innerHTML = _b
    });
  }

  var app = new Home();
});



//////////////////
// WEBPACK FOOTER
// ./src/js/consumer.js
// module id = 0
// module chunks = 3